import {
  useDevOverridesStore,
  type UserRecordsV2Override,
} from "@/lib/hooks/admin/use-dev-overrides";

export function resolveUserRecordsV2(override: UserRecordsV2Override): boolean {
  switch (override) {
    case "on":
    case "default":
      return true;
    case "off":
      return false;
    default: {
      const _exhaustive: never = override;
      return _exhaustive;
    }
  }
}

export function useUserRecordsV2(): boolean {
  const override = useDevOverridesStore((s) => s.userRecordsV2Override);
  return resolveUserRecordsV2(override);
}
